module.exports = __webpack_public_path__ + "static/media/prof2.92d4f867.png";